<template>
  <div>
    <Header />
    <main>
      <ErrorBoundary>
        <slot />
      </ErrorBoundary>
    </main>
    <FooterLuxury />
    <JoinListFloatingCta />
  </div>
</template>
